import React from 'react'

const styleHTML = `<style>

<!--

 /* Font Definitions */

 @font-face

	{font-family:Wingdings;

	panose-1:5 0 0 0 0 0 0 0 0 0;

	mso-font-charset:77;

	mso-generic-font-family:decorative;

	mso-font-pitch:variable;

	mso-font-signature:3 0 0 0 -2147483647 0;}

@font-face

	{font-family:"MS Mincho";

	panose-1:2 2 6 9 4 2 5 8 3 4;

	mso-font-alt:"ＭＳ 明朝";

	mso-font-charset:128;

	mso-generic-font-family:modern;

	mso-font-pitch:fixed;

	mso-font-signature:-536870145 1791491579 134217746 0 131231 0;}

@font-face

	{font-family:"Cambria Math";

	panose-1:2 4 5 3 5 4 6 3 2 4;

	mso-font-charset:0;

	mso-generic-font-family:roman;

	mso-font-pitch:variable;

	mso-font-signature:-536870145 1107305727 0 0 415 0;}

@font-face

	{font-family:DengXian;

	panose-1:2 1 6 0 3 1 1 1 1 1;

	mso-font-alt:等线;

	mso-font-charset:134;

	mso-generic-font-family:auto;

	mso-font-pitch:variable;

	mso-font-signature:-1610612033 953122042 22 0 262159 0;}

@font-face

	{font-family:Calibri;

	panose-1:2 15 5 2 2 2 4 3 2 4;

	mso-font-charset:0;

	mso-generic-font-family:swiss;

	mso-font-pitch:variable;

	mso-font-signature:-536859905 -1073732485 9 0 511 0;}

@font-face

	{font-family:"MS PMincho";

	panose-1:2 2 6 0 4 2 5 8 3 4;

	mso-font-alt:"ＭＳ Ｐ明朝";

	mso-font-charset:128;

	mso-generic-font-family:roman;

	mso-font-pitch:variable;

	mso-font-signature:-536870145 1791491579 134217746 0 131231 0;}

@font-face

	{font-family:"\@MS Mincho";

	panose-1:2 2 6 9 4 2 5 8 3 4;

	mso-font-charset:128;

	mso-generic-font-family:modern;

	mso-font-pitch:fixed;

	mso-font-signature:-536870145 1791491579 134217746 0 131231 0;}

@font-face

	{font-family:"\@DengXian";

	panose-1:2 1 6 0 3 1 1 1 1 1;

	mso-font-charset:134;

	mso-generic-font-family:auto;

	mso-font-pitch:variable;

	mso-font-signature:-1610612033 953122042 22 0 262159 0;}

@font-face

	{font-family:"\@MS PMincho";

	mso-font-charset:128;

	mso-generic-font-family:roman;

	mso-font-pitch:variable;

	mso-font-signature:-536870145 1791491579 134217746 0 131231 0;}

 /* Style Definitions */

 p.MsoNormal, li.MsoNormal, div.MsoNormal

	{mso-style-unhide:no;

	mso-style-qformat:yes;

	mso-style-parent:"";

	margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

p.MsoFootnoteText, li.MsoFootnoteText, div.MsoFootnoteText

	{mso-style-priority:99;

	mso-style-link:"Footnote Text Char";

	margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

p.MsoCommentText, li.MsoCommentText, div.MsoCommentText

	{mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-link:"Comment Text Char";

	margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

p.MsoHeader, li.MsoHeader, div.MsoHeader

	{mso-style-priority:99;

	mso-style-link:"Header Char";

	margin:0in;

	mso-pagination:widow-orphan;

	tab-stops:center 3.25in right 6.5in;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;

	mso-fareast-language:JA;}

p.MsoFooter, li.MsoFooter, div.MsoFooter

	{mso-style-priority:99;

	mso-style-link:"Footer Char";

	margin:0in;

	mso-pagination:widow-orphan;

	tab-stops:center 3.25in right 6.5in;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;

	mso-fareast-language:JA;}

span.MsoFootnoteReference

	{mso-style-priority:99;

	vertical-align:super;}

span.MsoCommentReference

	{mso-style-noshow:yes;

	mso-style-priority:99;

	mso-ansi-font-size:9.0pt;

	mso-bidi-font-size:9.0pt;}

p

	{mso-style-noshow:yes;

	mso-style-priority:99;

	margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Times New Roman",serif;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;}

p.MsoCommentSubject, li.MsoCommentSubject, div.MsoCommentSubject

	{mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-parent:"Comment Text";

	mso-style-link:"Comment Subject Char";

	mso-style-next:"Comment Text";

	margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;

	font-weight:bold;}

p.MsoAcetate, li.MsoAcetate, div.MsoAcetate

	{mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-link:"Balloon Text Char";

	margin:0in;

	mso-pagination:widow-orphan;

	font-size:9.0pt;

	font-family:"Calibri Light",sans-serif;

	mso-ascii-font-family:"Calibri Light";

	mso-ascii-theme-font:major-latin;

	mso-fareast-font-family:"DengXian Light";

	mso-fareast-theme-font:major-fareast;

	mso-hansi-font-family:"Calibri Light";

	mso-hansi-theme-font:major-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:major-bidi;}

p.MsoRMPane, li.MsoRMPane, div.MsoRMPane

	{mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-style-parent:"";

	margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;

	mso-fareast-language:JA;}

p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph

	{mso-style-priority:34;

	mso-style-unhide:no;

	mso-style-qformat:yes;

	margin-top:0in;

	margin-right:0in;

	margin-bottom:0in;

	margin-left:.5in;

	mso-add-space:auto;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

p.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst

	{mso-style-priority:34;

	mso-style-unhide:no;

	mso-style-qformat:yes;

	mso-style-type:export-only;

	margin-top:0in;

	margin-right:0in;

	margin-bottom:0in;

	margin-left:.5in;

	mso-add-space:auto;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

p.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle

	{mso-style-priority:34;

	mso-style-unhide:no;

	mso-style-qformat:yes;

	mso-style-type:export-only;

	margin-top:0in;

	margin-right:0in;

	margin-bottom:0in;

	margin-left:.5in;

	mso-add-space:auto;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

p.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast

	{mso-style-priority:34;

	mso-style-unhide:no;

	mso-style-qformat:yes;

	mso-style-type:export-only;

	margin-top:0in;

	margin-right:0in;

	margin-bottom:0in;

	margin-left:.5in;

	mso-add-space:auto;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

span.CommentTextChar

	{mso-style-name:"Comment Text Char";

	mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-style-locked:yes;

	mso-style-link:"Comment Text";}

span.CommentSubjectChar

	{mso-style-name:"Comment Subject Char";

	mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-style-locked:yes;

	mso-style-parent:"Comment Text Char";

	mso-style-link:"Comment Subject";

	font-weight:bold;}

span.BalloonTextChar

	{mso-style-name:"Balloon Text Char";

	mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-style-locked:yes;

	mso-style-link:"Balloon Text";

	mso-ansi-font-size:9.0pt;

	mso-bidi-font-size:9.0pt;

	font-family:"Calibri Light",sans-serif;

	mso-ascii-font-family:"Calibri Light";

	mso-ascii-theme-font:major-latin;

	mso-fareast-font-family:"DengXian Light";

	mso-fareast-theme-font:major-fareast;

	mso-hansi-font-family:"Calibri Light";

	mso-hansi-theme-font:major-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:major-bidi;}

p.Default, li.Default, div.Default

	{mso-style-name:Default;

	mso-style-unhide:no;

	mso-style-parent:"";

	margin:0in;

	mso-pagination:none;

	mso-layout-grid-align:none;

	text-autospace:none;

	font-size:12.0pt;

	font-family:"MS PMincho",serif;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"MS PMincho";

	color:black;

	mso-fareast-language:JA;}

span.FootnoteTextChar

	{mso-style-name:"Footnote Text Char";

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-style-locked:yes;

	mso-style-link:"Footnote Text";}

span.FootnoteTextChar1

	{mso-style-name:"Footnote Text Char1";

	mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-ansi-font-size:10.0pt;

	mso-bidi-font-size:10.0pt;}

span.HeaderChar

	{mso-style-name:"Header Char";

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-style-locked:yes;

	mso-style-link:Header;

	mso-fareast-language:JA;}

span.FooterChar

	{mso-style-name:"Footer Char";

	mso-style-priority:99;

	mso-style-unhide:no;

	mso-style-locked:yes;

	mso-style-link:Footer;

	mso-fareast-language:JA;}

span.SpellE

	{mso-style-name:"";

	mso-spl-e:yes;}

span.GramE

	{mso-style-name:"";

	mso-gram-e:yes;}

.MsoChpDefault

	{mso-style-type:export-only;

	mso-default-props:yes;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-fareast-font-family:DengXian;

	mso-fareast-theme-font:minor-fareast;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;

	mso-font-kerning:0pt;

	mso-ligatures:none;}

 /* Page Definitions */

 @page

	{mso-page-border-surround-header:no;

	mso-page-border-surround-footer:no;

	mso-footnote-separator:url("HP沖縄語自然会話コーパス%20\(12\).fld/header.html") fs;

	mso-footnote-continuation-separator:url("HP沖縄語自然会話コーパス%20\(12\).fld/header.html") fcs;

	mso-endnote-separator:url("HP沖縄語自然会話コーパス%20\(12\).fld/header.html") es;

	mso-endnote-continuation-separator:url("HP沖縄語自然会話コーパス%20\(12\).fld/header.html") ecs;}

@page WordSection1

	{size:8.5in 11.0in;

	margin:1.0in 1.0in 1.0in 1.0in;

	mso-header-margin:.5in;

	mso-footer-margin:.5in;

	mso-paper-source:0;}

div.WordSection1

	{page:WordSection1;}

 /* List Definitions */

 @list l0

	{mso-list-id:236599058;

	mso-list-type:hybrid;

	mso-list-template-ids:306762048 67698703 67698713 67698715 67698703 67698713 67698715 67698703 67698713 67698715;}

@list l0:level1

	{mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l0:level2

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l0:level3

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l0:level4

	{mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l0:level5

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l0:level6

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l0:level7

	{mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l0:level8

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l0:level9

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l1

	{mso-list-id:624845610;

	mso-list-type:hybrid;

	mso-list-template-ids:683338152 67698689 67698691 67698693 67698689 67698691 67698693 67698689 67698691 67698693;}

@list l1:level1

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l1:level2

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l1:level3

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l1:level4

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l1:level5

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l1:level6

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l1:level7

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l1:level8

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l1:level9

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l2

	{mso-list-id:671030015;

	mso-list-type:hybrid;

	mso-list-template-ids:-1231680460 1052670156 67698713 67698715 67698703 67698713 67698715 67698703 67698713 67698715;}

@list l2:level1

	{mso-level-text:"\(%1\)";

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l2:level2

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l2:level3

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l2:level4

	{mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l2:level5

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l2:level6

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l2:level7

	{mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l2:level8

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l2:level9

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l3

	{mso-list-id:1026831681;

	mso-list-type:hybrid;

	mso-list-template-ids:2087647742 67698689 67698691 67698693 67698689 67698691 67698693 67698689 67698691 67698693;}

@list l3:level1

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l3:level2

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l3:level3

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l3:level4

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l3:level5

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l3:level6

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l3:level7

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l3:level8

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l3:level9

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l4

	{mso-list-id:1043671766;

	mso-list-type:hybrid;

	mso-list-template-ids:536480822 67698689 67698691 67698693 67698689 67698691 67698693 67698689 67698691 67698693;}

@list l4:level1

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l4:level2

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l4:level3

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l4:level4

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l4:level5

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l4:level6

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l4:level7

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l4:level8

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l4:level9

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l5

	{mso-list-id:1537424723;

	mso-list-type:hybrid;

	mso-list-template-ids:-682038746 67698689 67698691 67698693 67698689 67698691 67698693 67698689 67698691 67698693;}

@list l5:level1

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l5:level2

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l5:level3

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l5:level4

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l5:level5

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l5:level6

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l5:level7

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l5:level8

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l5:level9

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l6

	{mso-list-id:1646161831;

	mso-list-type:hybrid;

	mso-list-template-ids:549212580 244469024 67698713 67698715 67698703 67698713 67698715 67698703 67698713 67698715;}

@list l6:level1

	{mso-level-text:"\(%1\)";

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l6:level2

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l6:level3

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l6:level4

	{mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l6:level5

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l6:level6

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l6:level7

	{mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l6:level8

	{mso-level-number-format:alpha-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;}

@list l6:level9

	{mso-level-number-format:roman-lower;

	mso-level-tab-stop:none;

	mso-level-number-position:right;

	text-indent:-9.0pt;}

@list l7

	{mso-list-id:1753771356;

	mso-list-type:hybrid;

	mso-list-template-ids:387479662 67698689 67698691 67698693 67698689 67698691 67698693 67698689 67698691 67698693;}

@list l7:level1

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l7:level2

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l7:level3

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l7:level4

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l7:level5

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l7:level6

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

@list l7:level7

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Symbol;}

@list l7:level8

	{mso-level-number-format:bullet;

	mso-level-text:o;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:"Courier New";}

@list l7:level9

	{mso-level-number-format:bullet;

	mso-level-text:;

	mso-level-tab-stop:none;

	mso-level-number-position:left;

	text-indent:-.25in;

	font-family:Wingdings;}

ol

	{margin-bottom:0in;}

ul

	{margin-bottom:0in;}

-->

</style>

<!--[if gte mso 10]>

<style>

 /* Style Definitions */

 table.MsoNormalTable

	{mso-style-name:"Table Normal";

	mso-tstyle-rowband-size:0;

	mso-tstyle-colband-size:0;

	mso-style-noshow:yes;

	mso-style-priority:99;

	mso-style-parent:"";

	mso-padding-alt:0in 5.4pt 0in 5.4pt;

	mso-para-margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;}

table.MsoTableGrid

	{mso-style-name:"Table Grid";

	mso-tstyle-rowband-size:0;

	mso-tstyle-colband-size:0;

	mso-style-priority:39;

	mso-style-unhide:no;

	border:solid windowtext 1.0pt;

	mso-border-alt:solid windowtext .5pt;

	mso-padding-alt:0in 5.4pt 0in 5.4pt;

	mso-border-insideh:.5pt solid windowtext;

	mso-border-insidev:.5pt solid windowtext;

	mso-para-margin:0in;

	mso-pagination:widow-orphan;

	font-size:12.0pt;

	font-family:"Calibri",sans-serif;

	mso-ascii-font-family:Calibri;

	mso-ascii-theme-font:minor-latin;

	mso-hansi-font-family:Calibri;

	mso-hansi-theme-font:minor-latin;

	mso-bidi-font-family:"Times New Roman";

	mso-bidi-theme-font:minor-bidi;

	mso-fareast-language:JA;}

</style>`


const bodyHTML = `<body lang=EN-US style='tab-interval:.5in;word-wrap:break-word'>



<div class=WordSection1>



<p class=MsoNormal><b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>沖縄語自然会話コーパス</span></b><b><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></b></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>本コーパスは、科研プロジェクト</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>(19K13171) </span><span lang=JA

style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>の一貫として開発されました</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>(</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>申請者</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>: </span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>新垣友子</span><span lang=JA

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'> </span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>沖縄キリスト教学院大学</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>)</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>。沖縄語自然会話のみを扱い、文法・語彙レベルでの沖縄語による検索を可能にしたコーパスで、独自の設計で構築されています</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>(</span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>開発担当者</span><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'>: </span><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>新里瑠美子</span><span

lang=JA style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'> </span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>ジョージア工科大学</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>)</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>。本コーパスが、オープンソースとして、利用者一般の皆様の沖縄語習得、研究者のプロジェクト推進の一助となれば幸いです。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>本コーパスの特徴</span></b><b><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></b></p>



<p class=MsoListParagraphCxSpFirst style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>基本語彙、並びに文法項目の使用頻度解析機能を組み入れているため、量的分析が可能である。　</span><span style='font-size:

11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>抽出された使用例は、</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>csv format</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>で表化でき、ワードあるいはエクセルへの変換保存が可能である。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>音声が付与されているため、沖縄語学習者に有益であるだけでなく、音韻・音声研究にも活用可能である。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>メタ情報も公開されているため、話者の関係、年齢・出身地情報、談話状況へのアクセスが可能である。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>日常会話の中で話されている沖縄語を収録しており、ありのままの、自然な会話の記録であるため、特に談話研究の資料として活用できる。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>会話内容が多岐に亘っているため、歴史的資料としての意義も認められる。</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpLast><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>コーパス開発までの経緯</span></b><b><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></b></p>



<p class=MsoListParagraphCxSpFirst style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>2019</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>年度から、収録開始し、回数</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>10</span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>回、収録時間</span><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'>15</span><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>時間弱のデータより、比較的ノイズの少ない、音声明瞭な部分を抽出、ブロックとして編集した。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>抽出ブロックは文字化し、日本語訳を付し、コーパスデータとして組み入れた。その際、個人情報は音声資料からも文字資料からも削除し、個人情報保護に努めた。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>テーマ別研究を可能にするため、ブロックごとに、大まかな見出し</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>(</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>トピック</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>)</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>をつけ、音声も付与した。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpLast style='text-indent:-.25in;mso-list:l3 level1 lfo2'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>音声再生はバーの位置を変えることで、途中からの再生も可能である。</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>謝辞</span></b><b><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></b></p>



<p class=MsoNormal><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>本コーパスは下記の方々の協力を得て開発されました。ここに厚く御礼申し上げます。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>　録音参加者</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>:</span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>うちなー<span class=GramE>ぐち</span>母語話者</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>22</span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>名</span><span lang=JA style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'> </span><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'><o:p></o:p></span></p>



<p class=MsoNormal><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>　文字化・日本語訳協力者</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>: </span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>山城成子</span><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'><span style='mso-spacerun:yes'>  </span></span><span lang=JA

style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>佐久川盛光</span><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'><o:p></o:p></span></p>



<p class=MsoNormal><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>　コーパス開発技術者</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>: Kenneth S. Simonds<o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>最後に</span></b><b><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></b></p>



<p class=MsoNormal><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>危機言語の記録・復興が叫ばれて久しいのですが、本プロジェクトが、その大きな目標への小さな一歩となれば、企画者の喜びとなるところです。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>お問合せ</span></b><b><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></b></p>



<p class=MsoNormal><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>ご質問、ご意見等は企画者までお寄せください。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><span

style='mso-spacerun:yes'>   </span></span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>新垣友子</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>:

tomoko@ocjc.ac.jp<o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><span

style='mso-spacerun:yes'>   </span></span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>新里瑠美子</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>:

rumiko.shinzato@gatech.edu<o:p></o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><span lang=JA style='font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>文字化の原則</span><span style='font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'>(</span><span lang=JA style='font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>概ね宇佐美まゆみ先生の</span><span

style='font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>BTSJ[<b>Basic Transcription System for Japanese: BTSJ </b>]2007</span><span

lang=JA style='font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>年</span><span style='font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>3</span><span

lang=JA style='font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>月</span><span style='font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>31</span><span

lang=JA style='font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>日改訂版を参考に、簡略化しております。</span><span style='font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'>)<o:p></o:p></span></p>



<p class=MsoNormal><span style='font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS PMincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoListParagraphCxSpFirst style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman";mso-fareast-language:JA'><span style='mso-list:Ignore'>(1)<span

style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><b

style='mso-bidi-font-weight:normal'><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>話者情報</span></b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>：　話者は、イニシャルで示し、メタデータと連結可能にする。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman";mso-fareast-language:JA'><span style='mso-list:Ignore'>(2)<span

style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><b

style='mso-bidi-font-weight:normal'><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>話者交替</span></b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>：　話者が交替する度に改行する。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman";mso-fareast-language:JA'><span style='mso-list:Ignore'>(3)<span

style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><b

style='mso-bidi-font-weight:normal'><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>発話文終了</span></b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>：　記号は、「</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>?_</span><span lang=JA style='font-size:

11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>」、「。」、「</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>…</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>」</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>(</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>淀み</span><span style='font-size:

11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>)</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>を用いる。</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman";mso-fareast-language:JA'><span style='mso-list:Ignore'>(4)<span

style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><b

style='mso-bidi-font-weight:normal'><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>発話文小休止</span></b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>：　スペースを入れ、意味的まとまりとして解釈できる場合は改行する。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman";mso-fareast-language:JA'><span style='mso-list:Ignore'>(5)<span

style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><b

style='mso-bidi-font-weight:normal'><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>スペース</span></b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>：　単語と単語の間、語幹と活用語尾の間には半角スペースを入れる</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpLast style='margin-left:21.3pt;mso-add-space:auto;

text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman";mso-fareast-language:JA'><span style='mso-list:Ignore'>(6)<span

style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><b

style='mso-bidi-font-weight:normal'><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>割り込み</span></b><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>：　会話の中で、第一話者に第二話者が割って入る場合、下記のように表記する</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=Default style='margin-left:.5in;text-align:justify;text-justify:inter-ideograph'><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman"'>→１</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho"'>A<span style='mso-tab-count:2'>              </span></span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman"'>それは、高校、でも【【あの</span><span class=GramE><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho"'>...</span></span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho"'><o:p></o:p></span></p>



<p class=Default style='margin-left:.5in;text-align:justify;text-justify:inter-ideograph;

tab-stops:14.2pt'><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman"'>→</span><span lang=JA style='font-size:

11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho"'>

</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho"'>2B<span style='mso-tab-count:2'>               </span></span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman"'>】】現代国語っていうと、あの、国語の</span><span class=GramE><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho"'>...</span></span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho"'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpFirst style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman"'><span style='mso-list:Ignore'>(7)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><b style='mso-bidi-font-weight:normal'><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>あいづち</span></b><span lang=JA

style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>：　相手の発話に重なる、短く、特別な意味を持たないあいづちは、相手の発話中の最も近い部分に、</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>(<span style='mso-spacerun:yes'>  </span>)

</span><span lang=JA style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman";mso-fareast-language:JA'>にくくって入れる。</span><span

lang=JA style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'> </span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho"'>_<o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle><b style='mso-bidi-font-weight:normal'><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>かぶる部分</span></b><span lang=JA

style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>：　同時発話されたところは、重なった部分双方を</span><span style='font-size:

11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>&lt;</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>　</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>&gt;</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>でくくる。　　</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpLast><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>→</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>1 A<span

style='mso-spacerun:yes'>  </span></span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>それは、それは、</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>&lt;</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>ごくろうさまです</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'>&gt; </span><span lang=JA

style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>。</span><span lang=JA style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'> </span><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'><o:p></o:p></span></p>



<p class=MsoNormal style='margin-left:14.2pt;text-indent:22.0pt;mso-char-indent-count:

2.0'><span lang=ZH-CN style='font-size:11.0pt;font-family:"MS Mincho";

mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman"'>→</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho"'>2

B<span style='mso-spacerun:yes'>  </span>&lt;</span><span lang=ZH-CN

style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman"'>いえいえ</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho"'>&gt; </span><span lang=ZH-CN style='font-size:11.0pt;font-family:

"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:"Times New Roman";

mso-bidi-font-family:"Times New Roman"'>。</span><span lang=ZH-CN

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho"'> </span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho"'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpFirst style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman"'><span style='mso-list:Ignore'>(8)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><b style='mso-bidi-font-weight:normal'><span

lang=ZH-CN style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman"'>音声的情報</span></b><span lang=ZH-CN style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman"'>：　よどみ</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho"'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l7 level1 lfo5'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>音声的に言い淀んだように聞こえるものには「</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>...</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>」をつける。</span><span style='font-size:

11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"Times New Roman";mso-bidi-font-weight:bold'><span style='mso-list:Ignore'>(9)<span

style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></span><![endif]><b

style='mso-bidi-font-weight:normal'><span lang=ZH-CN style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman"'>周辺言語情報</span></b><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-bidi-font-weight:bold'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='text-indent:-.25in;mso-list:l1 level1 lfo6'><![if !supportLists]><span

style='font-size:11.0pt;font-family:Symbol;mso-fareast-font-family:Symbol;

mso-bidi-font-family:Symbol;mso-fareast-language:JA'><span style='mso-list:

Ignore'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

</span></span></span><![endif]><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA;mso-bidi-font-weight:bold'>笑い</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>ながら発話したものや<span style='mso-bidi-font-weight:bold'>笑い</span>等は、</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA;mso-bidi-font-weight:bold'>{ }</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>の中に、</span><span style='font-size:

11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>{</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>笑いながら</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>}</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>、</span><span style='font-size:11.0pt;

font-family:"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";

mso-fareast-language:JA'>{2</span><span lang=JA style='font-size:11.0pt;

font-family:"MS Mincho";mso-ascii-font-family:"Times New Roman";mso-hansi-font-family:

"Times New Roman";mso-bidi-font-family:"Times New Roman";mso-fareast-language:

JA'>人で笑い</span><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'>}</span><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>などのように説明を記す。</span><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS Mincho";mso-fareast-language:JA'><o:p></o:p></span></p>



<p class=MsoListParagraphCxSpMiddle style='margin-left:21.3pt;mso-add-space:

auto;text-indent:-21.3pt;mso-list:l6 level1 lfo4'><![if !supportLists]><b

style='mso-bidi-font-weight:normal'><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"Times New Roman";mso-fareast-language:

JA'><span style='mso-list:Ignore'>(10)<span style='font:7.0pt "Times New Roman"'>&nbsp;

</span></span></span></b><![endif]><b style='mso-bidi-font-weight:normal'><span

lang=JA style='font-size:11.0pt;font-family:"MS Mincho";mso-ascii-font-family:

"Times New Roman";mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:

"Times New Roman";mso-fareast-language:JA'>発話内容に関する記号まとめ</span></b><b

style='mso-bidi-font-weight:normal'><span style='font-size:11.0pt;font-family:

"Times New Roman",serif;mso-fareast-font-family:"MS Mincho";mso-fareast-language:

JA'><o:p></o:p></span></b></p>



<p class=MsoListParagraphCxSpLast style='margin-left:21.3pt;mso-add-space:auto'><span

style='font-family:"MS PMincho",serif;mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 width=637

 style='margin-left:.05in;border-collapse:collapse;mso-table-layout-alt:fixed;

 border:none;mso-padding-alt:0in 5.4pt 0in 5.4pt'>

 <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes;height:4.95pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:4.95pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  class=GramE><span lang=JA style='font-size:11.0pt'>｡</span></span><span

  lang=JA style='font-size:11.0pt'> </span><span style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border:solid windowtext 1.0pt;

  border-left:none;mso-border-left-alt:solid windowtext .5pt;mso-border-alt:

  solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:4.95pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>［全角］</span><span style='font-size:11.0pt'> 1

  <span lang=JA>発話文の終わりにつける。 </span><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:1;height:19.5pt'>

  <td width=80 rowspan=2 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:19.5pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  class=GramE><span lang=JA style='font-size:11.0pt'>、</span></span><span

  lang=JA style='font-size:11.0pt'> </span><span style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:19.5pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>①［全角］</span><span style='font-size:11.0pt'>

  1<span lang=JA>発話文および</span>1<span lang=JA>ライン中で、日本語表記の慣例の通りに読点をつける。 </span><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:2;height:4.95pt'>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:4.95pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>②発話と発話のあいだに短い間がある場合につける。 </span><span

  style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:3;height:19.55pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:19.55pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>… </span><span style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:19.55pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>文中、文末に関係なく、音声的に言いよどんだように聞こえるものにつける。 </span><span

  style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:4;height:19.55pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:19.55pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  style='font-size:11.0pt'>?<o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:19.55pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>疑問文につける。疑問の終助詞がついた質問形式になっていなくても、語尾を上げるなどして、疑問の機能を持つ発話には、その部分が文末</span><span

  style='font-size:11.0pt'>(_<span lang=JA>発話文末</span>)<span lang=JA>なら「</span>?<span

  lang=JA>」をつける。倒置疑問の機能を持つものには、発話中に「</span>?<span lang=JA>」をつける。</span> _<o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:5;height:4.95pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:4.95pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>『 』 </span><span style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:4.95pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>視覚上、区別した方が分かりやすいと思われるもの、例えば、本や映画の題名のような固有名詞や、発話者がその発話の中で漢字の読み方を説明したような部分等は、『</span><span

  style='font-size:11.0pt'> _<span lang=JA>』でくくる。 </span><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:6;height:12.25pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt;mso-hansi-font-family:"MS PMincho"'>【【</span><span

  style='font-size:11.0pt;mso-hansi-font-family:"MS PMincho"'><o:p></o:p></span></p>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt;mso-hansi-font-family:"MS PMincho"'>】】</span><span

  style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='margin-left:.5in;text-align:justify;text-justify:

  inter-ideograph'><span lang=JA style='font-size:11.0pt;mso-hansi-font-family:

  "MS PMincho"'>→１</span><span style='font-size:11.0pt;mso-hansi-font-family:

  "MS PMincho"'>A<span style='mso-tab-count:2'>                </span><span

  lang=JA>それは、高校、でも</span>&lt;_<span lang=JA>あの…</span>&gt;<span lang=JA>　【【</span><o:p></o:p></span></p>

  <p class=Default style='margin-left:.5in;text-align:justify;text-justify:

  inter-ideograph;tab-stops:14.2pt'><span lang=JA style='font-size:11.0pt;

  mso-hansi-font-family:"MS PMincho"'>→</span><span style='font-size:11.0pt;

  mso-hansi-font-family:"MS PMincho"'>2-1B<span style='mso-tab-count:2'>             </span><span

  lang=JA>】】</span>&lt;<span lang=JA>現代国語っていうと、あの、国語の…</span><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:7;height:12.25pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  style='font-size:11.0pt'>&lt;<span lang=JA>　</span>&gt; <o:p></o:p></span></p>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  style='font-size:11.0pt'>&lt;<span style='mso-spacerun:yes'>  </span>&gt; <o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>同時発話されたものは、重なった部分双方を半角の</span><span

  style='font-size:11.0pt'>&lt; &gt;<span lang=JA>でくくり、 、そのラインの最後に句点「。」または</span></span><span

  class=GramE><span style='font-size:11.0pt;mso-hansi-font-family:"MS PMincho"'>...</span></span><span

  lang=JA style='font-size:11.0pt'>をつける。</span><span style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:8;height:12.25pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  style='font-size:11.0pt'>@@<o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>聴き取れないもの。</span><span style='font-size:11.0pt'><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:9;height:12.25pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  style='font-size:11.0pt'>XX YY<o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>個人名を伏せるために、実名の代わりに全角の</span><span

  style='font-size:11.0pt'>X<span lang=JA>や</span>Y<span lang=JA>を用いる。</span><o:p></o:p></span></p>

  </td>

 </tr>

 <tr style='mso-yfti-irow:10;mso-yfti-lastrow:yes;height:12.25pt'>

  <td width=80 valign=top style='width:59.95pt;border:solid windowtext 1.0pt;

  border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;

  padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  style='font-size:11.0pt'>[= ]<o:p></o:p></span></p>

  </td>

  <td width=558 valign=top style='width:418.15pt;border-top:none;border-left:

  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;

  mso-border-top-alt:solid windowtext .5pt;mso-border-left-alt:solid windowtext .5pt;

  mso-border-alt:solid windowtext .5pt;padding:0in 5.4pt 0in 5.4pt;height:12.25pt'>

  <p class=Default style='text-align:justify;text-justify:inter-ideograph'><span

  lang=JA style='font-size:11.0pt'>省略・融合形の分析に用いる。</span><span style='font-size:

  11.0pt'><o:p></o:p></span></p>

  </td>

 </tr>

</table>



<p class=MsoListParagraph style='margin-left:21.3pt;mso-add-space:auto'><span

style='font-family:"MS PMincho",serif;mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><span style='font-size:11.0pt;font-family:"Times New Roman",serif;

mso-fareast-font-family:"MS Mincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></p>



<p class=MsoNormal><b style='mso-bidi-font-weight:normal'><span

style='font-size:9.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS PMincho";mso-fareast-language:JA'><span

style='mso-spacerun:yes'>                                       </span></span></b><b

style='mso-bidi-font-weight:normal'><span lang=JA style='font-size:9.0pt;

font-family:"MS PMincho",serif;mso-ascii-font-family:"Times New Roman";

mso-hansi-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";

mso-fareast-language:JA'>　　　</span></b><b style='mso-bidi-font-weight:normal'><span

style='font-size:9.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS PMincho";mso-fareast-language:JA'><o:p></o:p></span></b></p>



<p class=MsoNormal><b style='mso-bidi-font-weight:normal'><span

style='font-size:11.0pt;font-family:"Times New Roman",serif;mso-fareast-font-family:

"MS PMincho";mso-fareast-language:JA'><o:p>&nbsp;</o:p></span></b></p>



<img src="${process.env.PUBLIC_URL}/corpus_table_1.png" alt="Corpus Table 1" style="max-width: 100%; height: auto;">

<img src="${process.env.PUBLIC_URL}/corpus_table_2.png" alt="Corpus Table 2" style="max-width: 100%; height: auto;">




</div>



</body>`

export default function About() {
  return (
    <div className='container-xxl'>
        <div className='row'>
            
            <div className='col-md-8 mx-auto'>
                <h4 style={{textAlign:"center"}}>沖縄語自然会話コーパス</h4>
                <br/>
                <style dangerouslySetInnerHTML={{ __html: styleHTML }} />
                <div dangerouslySetInnerHTML={{ __html: bodyHTML }} />
                
                
                
            </div>
            
        </div>

    
    </div>
  )
}
